var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconViewDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .IconViewDetails_a {\n                fill: #304669;\n            }\n\n            .IconViewDetails_b {\n                fill: #fff;\n                opacity: 0;\n            }\n\n            .IconViewDetails_c {\n                clip-path: url(#IconViewDetails_a);\n            }\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "IconViewDetails_a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "IconViewDetails_a",
    width: 17.581,
    height: 19.694
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1705 -299)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "IconViewDetails_b",
    width: 24,
    height: 24,
    transform: "translate(1705 299)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1958 546.229)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250 -245.228)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "IconViewDetails_c",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "IconViewDetails_a",
    d: "M-97.89-90.443a.707.707,0,0,0-.7-.7h-8.981a.707.707,0,0,0-.7.7.707.707,0,0,0,.7.7h8.981a.707.707,0,0,0,.7-.7Zm-9.686,3.507a.707.707,0,0,0-.7.7.707.707,0,0,0,.7.7h4.194a.7.7,0,0,0,.7-.7.707.707,0,0,0-.7-.7Zm10.1,7.217a.627.627,0,0,0-.151-.114,3.459,3.459,0,0,0,.63-2,3.526,3.526,0,0,0-3.549-3.5,3.526,3.526,0,0,0-3.549,3.5,3.526,3.526,0,0,0,3.549,3.5A3.574,3.574,0,0,0-98.6-78.9a.7.7,0,0,0,.127.176l1.828,1.828a.706.706,0,0,0,1,0,.706.706,0,0,0,0-1Zm-3.071.013a2.137,2.137,0,0,1-2.151-2.122,2.137,2.137,0,0,1,2.151-2.122,2.137,2.137,0,0,1,2.151,2.122,2.136,2.136,0,0,1-2.151,2.122Zm0,0",
    transform: "translate(112.168 95.375)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "IconViewDetails_a",
    d: "M-239.572-226.736h-7.822a1.409,1.409,0,0,1-1.4-1.4v-14.016a1.409,1.409,0,0,1,1.4-1.4h12.012a1.409,1.409,0,0,1,1.4,1.4v6.988h.007v0a.706.706,0,0,0,.707.7.706.706,0,0,0,.707-.7c0-.026,0-.051,0-.077v-6.936c0-1.545-.606-2.809-2.151-2.809h-12.6a2.818,2.818,0,0,0-2.809,2.809v14.043a2.818,2.818,0,0,0,2.809,2.809h7.73a.706.706,0,0,0,.707-.7.705.705,0,0,0-.7-.7Zm0,0",
    transform: "translate(250.117 244.995)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "IconViewDetails_a",
    d: "M338.439,190.437a.707.707,0,1,0,.353-.61.7.7,0,0,0-.353.61Zm0,0",
    transform: "translate(-572.295 -423.027)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewDetails);
export default __webpack_public_path__ + "static/media/IconViewDetails.766ad1151ff844a369f137d333c07810.svg";
export { ForwardRef as ReactComponent };